import { useEffect, useState } from "react";
import { ImageIcon } from "lucide-react";
import { api, fileUrl } from "../lib/api";

export default function Gallery() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/gallery").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  return (
    <div className="container-oxy py-10 sm:py-14" data-testid="gallery-page">
      <p className="eyebrow">La boutique</p>
      <h1 className="mt-1 font-display text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">Galerie</h1>

      {items === null ? (
        <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-3">
          {Array.from({ length: 3 }).map((_, i) => <div key={i} className="aspect-square animate-pulse rounded-2xl bg-slate-100" />)}
        </div>
      ) : items.length === 0 ? (
        <div className="mt-8 rounded-3xl border border-dashed border-slate-300 bg-white p-12 text-center" data-testid="gallery-empty">
          <ImageIcon className="mx-auto h-10 w-10 text-slate-300" />
          <p className="mt-3 font-display font-semibold text-slate-800">Photos bientôt disponibles</p>
          <p className="mt-1 text-sm text-slate-500">La galerie de la boutique est en cours de préparation.</p>
        </div>
      ) : (
        <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-3 sm:gap-5" data-testid="gallery-grid">
          {items.map((g) => (
            <figure key={g.id} data-testid={`gallery-item-${g.id}`} className="card-oxy overflow-hidden">
              <img src={fileUrl(g.image)} alt={g.caption || "Photo de la boutique"} loading="lazy"
                className="aspect-square w-full object-cover" />
              {g.caption && <figcaption className="p-3 text-xs font-semibold text-slate-600">{g.caption}</figcaption>}
            </figure>
          ))}
        </div>
      )}
    </div>
  );
}
